enum CommentsConfig {
  COMMENTS_PAGE_LIMIT = 15,
  SUB_COMMENTS_PAGE_LIMIT = 5,
}

export default CommentsConfig
